import config from '../../../config';

const UPLOADS_PATH = 'uploads/';

export const buildFormulaImageUrl = (img: string): string => {
  const domain = config.s3Url.replace(/\/+$/, '');
  const imgWithPath = img.includes(UPLOADS_PATH) ? img : UPLOADS_PATH + img;
  return `${domain}/${imgWithPath}`;
};
